<div class="privacy-content" [innerHTML]="terms"></div>
